import { Country } from "@core/schema/Country.js";

export const defaultDestinationCountry = Country.Czechia;
